import SelectContact from "@/views/crud/modules/SelectContact";
import EditViewList from "@/views/crud/modules/EditViewList";
import BaseSelect from "@/views/crud/modules/BaseSelect";

export default {
  key: "campaign",
  id: "id",
  export: ["excel"],
  excel: {
     //max_row: "50000" 
  },
  sort: {
    field: "id",
    order: "desc"
  },
  sort_fields: [
    "id",
    // "name",
    // "nameCHT",
    // "nameCHS",
    // "applicableTime",
    // "applicableTimeCHT",
    // "applicableTimeCHS",
    "externalCampaignId",
    // "tnc",
    // "tncCHT",
    // "tncCHS"
  ],
  filters: {
    id: {},
    name: {},
    nameCHT: {},
    // nameCHS: {},
    // applicableTime: {},
    // applicableTimeCHT: {},
    // applicableTimeCHS: {},
    externalCampaignId: {},
    // tnc: {},
    // tncCHT: {},
    // tncCHS: {},
    isAllCpLocFlag: {
      type: "boolean"
    },
    addresses:{},
    locIds:{
      type: "select",
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
    creUserName: {},
  },
  fields: [
    { key: "id", width: 40},
    { key: "externalCampaignId", width: 200},
    { key: "name", width: 250},
    { key: "nameCHT", width: 250},
    { key: "nameCHS",width: 200, hidden: ["list"]},
    { key: "faceValue", width: 200},
    { key: "applicableTime", width: 250},
    { key: "applicableTimeCHT", width: 250},
    { key: "applicableTimeCHS", width: 200, hidden: ["list"]},
    { key: "tnc",width: 200, row:10000, hidden: ["list"]},
    { key: "tncCHT", width: 200, row:10000, hidden: ["list"]},
    { key: "tncCHS",width: 200, row:10000, hidden: ["list"]},
    { key: "isAllCpLocFlag", width:50, type: "boolean", hidden: ["list"]},
    { key: "creUserName",hidden:["create"], width: 100},
    { key: "demoImage", hidden: ["list"], type: "image", imageSrc: "/shk/campaigndemo.png"},
    // { key: "addresses", width: "200px"},
    { key: "locIds", type:"componentColumn", component:BaseSelect, filterable:false, optionKey: "cp_locs", setup:{label:'label',value:'value'}, disabledFun:d=>d.isAllCpLocFlag==1 , width: 450},

    // { key: "creUser"},
    // { key: "creUserName",hidden:["create"], width: 120},
    // { key: "locIds", type:"componentColumn", label:"address", value:"loc_id", get_option:"cp_locs", get_data:"campaign_and_cp_loc", component:SelectContact, hidden: ["list"], disabledFun:d=>d.isAllCpLocFlag==1,},
    // { key: "locIds", type:"componentColumn", component:BaseSelect, filterable:true, optionKey: "cp_locs", setup:{label:'label',value:'value'}, disabledFun:d=>d.isAllCpLocFlag==1, hidden: ["list"]},
    { type: "action-btn", width: 120},

  ],
  structure: [
    ["externalCampaignId"],
    ["name","nameCHT","nameCHS"],
    // ["applicableTime","applicableTimeCHT","applicableTimeCHS"],
    ["faceValue"],
    ["tnc"],
    ["tncCHT"],
    ["tncCHS"],
    ["isAllCpLocFlag"],
    ["locIds"],
    ["demoImage"]
  ],
  action: ["create","edit","view","editview"],
  action_setup: {
    edit:[
      {key:"isVoucher", val:0, type:"eq"}
    ],
    editview:[
      {key:"isVoucher", val:0, type:"eq"}
    ]
  },
  // action: ["create","edit","view","delete"],
  options: {
    locIds: {
      key: "cp_locs",
      label: "address",
      value: "loc_id"
    },
  },
  view: [
    ["externalCampaignId"],
    ["name","nameCHT","nameCHS"],
    ["faceValue"],
    ["applicableTime","applicableTimeCHT","applicableTimeCHS"],
    ["tnc","tncCHT","tncCHS"],
    ["isAllCpLocFlag"],
    [{ key: "locIds",  show:"string", type:"componentColumn", label:"address", value:"loc_id", get_option:"cp_locs", get_data:"campaign_and_cp_loc", component:SelectContact}],
  ],
  extra_components: {
  },
  disabled_by_column:{
  },
  extra_privillege_components: {
    editview: [
      {key:"campaignId", path:"campaign_rule",component:EditViewList}
    ],
    view: [
      {key:"campaignId", path:"campaign_rule",component:EditViewList}
    ]
  }
}